export const CycleCommunicationMilestoneType = {
    PROJECT_KICK_OFF: 'ProjectKickOff',
    MANAGER_ASSESSMENT_LAUNCH: 'ManagerAssessmentLaunch',
    MANAGER_DEADLINE: 'ManagerDeadline',
    DISCUSSION_EMAIL: 'DiscussionEmail',
    EVALUATION_CYCLE_CLOSURE: 'EvaluationCycleClosure',
} as const;

export type CycleCommunicationMilestoneTypeValue =
    (typeof CycleCommunicationMilestoneType)[keyof typeof CycleCommunicationMilestoneType];

export const CycleCommunicationRecipientType = {
    MANAGER: 'Manager',
    EMPLOYEE: 'Employee',
} as const;

export type CycleCommunicationRecipientTypeValue =
    (typeof CycleCommunicationRecipientType)[keyof typeof CycleCommunicationRecipientType];
